import {useProjects} from '../../../providers/projects/useProjects.ts'
import {useSubscription} from '../../../providers/subscription/useSubscription.ts'
import {routes} from '../../../routes.ts'
import {useNavigate} from 'react-router-dom'
import {validAmountOfProjectsForTier} from '@package/shared'
import {SubscriptionErrorBanner} from './SubscriptionErrorBanner.tsx'

export const TooManyProjectsErrorBanner = () => {
  const navigate = useNavigate()
  const {activeSubscriptionTier, loading: loadingSubscriptions} = useSubscription()
  const {activeProjects, loading: loadingProjects} = useProjects()

  if (loadingSubscriptions || loadingProjects) return null

  if (activeSubscriptionTier.tier === 'none') return null

  if (validAmountOfProjectsForTier(activeSubscriptionTier, activeProjects)) return null

  return (
    <SubscriptionErrorBanner
      title={'Time tracking disabled'}
      buttons={[
        {
          title: 'Manage projects',
          onClick: () => navigate(routes.projects.buildRoute()),
        },
      ]}
    >
      You have too many active projects for your current subscription!
    </SubscriptionErrorBanner>
  )
}
